/*
Akhila 01/05/2023 3075154998 PrePopulated static preprocessor data In Ui
Ravi 02/06/2023 3075154998 fixed Field column data display issue
suresh peddavoora 02/27/2023 3075154998 textfields alignments fixes
*/
import React from 'react';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {tableIcons} from '../../../../../../components/TableIcons';

const getStatusParameters = (params) => {
  const ar = [];
  Object.entries(params).forEach(([key, value]) => {
    if (key === 'disposition') {
      value ? ar.push(`status : "${value}"`) : null;
    } else if (key !== 'dispositionType') {
      value ? ar.push(`${key} : "${value}"`) : null;
    }
  });
  return ar.filter(Boolean).join(', ');
};
const ActionTable = ({data}) => {
  const tableData =
    data?.length > 0 ?
      data.map((el, index) => {
        return {
          actionName: el.actionName,
          fieldFromType: `${el.repositoryFromName}.${el.fieldFromName}`,
          compareValue: el.compareValue,
          rhsRuleExpression:
          el?.actionName === 'Change Status' ?
            getStatusParameters(el?.rhsRuleExpression) :
            el?.rhsRuleExpression ?
              el?.rhsRuleExpression :
              el?.rhsFormulaExpression ?
                el?.rhsFormulaExpression :
                '',
          seqno: index + 1,
        };
      }) :
      [];

  const columns = [
    {
      title: 'SEQ No',
      field: 'seqno',
    },
    {
      title: 'Action(s)',
      field: 'actionName',
    },
    {
      title: 'Field',
      field: 'fieldFromType',
    },
    {
      title: 'Parameter(s)',
      field: 'rhsRuleExpression',
    },
  ];
  return (
    <>
      <div className="custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields">
        <GuiTable
          title={''}
          columns={columns}
          icons={tableIcons}
          data={tableData}
          options={{
            toolbarButtonAlignment: 'left',
            toolbar: false,
            search: false,
            emptyRowsWhenPaging: false,
            paging: false,
            headerStyle: {
              fontWeight: 'bold',
              fontSize: '0.938rem',
              padding: '16px',
            },
          }}
        />
      </div>
    </>
  );
};

export default ActionTable;
